import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccMentorDropout, MentorDropoutsGridServiceInterface } from '../mentor-dropouts-grid.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(parent: string, util: UtilityService, dialogService: DialogService, service: MentorDropoutsGridServiceInterface): GridSetup<AccMentorDropout> {

	const staffPermissions = service.areaService.staffPermissions();

	return {
		rowName: { singular: 'Mentor Dropout', plural: 'Mentor Dropouts' },
		getRowKey: row => '' + row.dropoutId,
		stateKey: `${parent}-delivery-mentor-dropouts-grid`,
		actions: getActions(dialogService, service),
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${service.areaService.selectedTrimesterName()}-Mentor-Dropouts`
		}
	}
}
